import { useRef, useState, useEffect, useContext } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { TextField, Button } from '@mui/material';
import axios from "axios";
import dayjs from 'dayjs';
//import { AuthInfoContext } from "./AuthContextProvider.tsx";
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import { API, MSG } from "./constantsFront";
import { MsgContext } from '../../App';

/**
 * 更新履歴登録・変更
 * @returns 
 */

function G012NewsEdit() {
  // useEffect初回読込フラグ
  const refIsFirst = useRef(true);

  const location = useLocation();
  const navigate = useNavigate();

  // エラーメッセージ
  const { msg, setMsg } = useContext(MsgContext);
  var select_news_id = '';

  if (location.state != null) {
    select_news_id = location.state.ID; // 選択したお知らせのnews_id
    window.localStorage.setItem("select_news_id", select_news_id); // ローカルストレージに保存する
  } else {
    select_news_id = window.localStorage.getItem("select_news_id"); // ローカルストレージから取り出す
  }

  const [maxid, setMaxId] = useState(0);
  const [Title, setTitle] = useState(''); // タイトル
  const [Content, setContent] = useState(''); // 本文
  const [PublishDate, setPublishDate] = useState(''); // 公開日時

  const [titleMsg, setTitleMsg] = useState(""); // 必須チェック用メッセージ(タイトル)
  const [publishDateMsg, setPublishDateMsg] = useState(""); // 必須チェック用メッセージ(公開日時)
  const [newsMain, setNewsMain] = useState(""); // Edit画面表題

  var maxnewsid = '';
  let body = { authKey: API.API_KEY };

  useEffect(() => {
    // 初回読込チェック
    if (!refIsFirst.current) {
      return;
    }

    if (select_news_id == -1) {
      getMaxNewsId();
      setNewsMain("更新履歴新規登録");
    } else {
      getNews();
      setNewsMain("更新履歴編集");
    }

    // 初回読込フラグをfalseにセット
    refIsFirst.current = false;

  }, [])

  // 更新履歴取得
  async function getNews() {
    var newsList = [];
    body.newsid = select_news_id;
    await axios.post("/m_news/select/", body).then(res => {
      newsList = res.data.newsList;
    });

    var publish_date = dayjs(newsList[0].publish_date).format('YYYY-MM-DD HH:mm:ss');

    setTitle(newsList[0].title);
    setContent(newsList[0].content);
    setPublishDate(publish_date);
  }

  // news_idの最大値取得
  async function getMaxNewsId() {
    await axios.post("/m_news/select/maxnewsid/auth", body)
      .then(res => {
        // 認証チェック
        if (res.status != 200) {
          return;
        }

        // データが取得できた時の処理
        maxnewsid = res.data.maxnews;

        // newsidの最大値が0以上の場合は+1する
        if (maxnewsid[0].id != null && maxnewsid[0].id >= 0) {
          setMaxId(maxnewsid[0].id + 1);
        } else {
          setMaxId(0);
        }
      }).catch(error => {
        console.log('error:', error);
        setMsg(MSG.EXCEPTION);
      });

  }

  // 保存処理
  async function register() {
    try {
      console.log('保存処理開始');

      var csletr = [];
      var arrStr = [];

      if (!Title) {
        // return setTitleMsg(<Alert severity="error">タイトルは必須です</Alert>);
        setTitleMsg("タイトルは必須です");
      } else {
        setTitleMsg("");
      }

      if (!PublishDate) {
        // return setPublishDateMsg(<Alert severity="error">公開日時は必須です</Alert>);
        setPublishDateMsg("公開日時は必須です");
      } else {
        setPublishDateMsg("");
      }
      if (!Title || !PublishDate) {
        return;
      }

      // news_idの振り分け
      if (select_news_id == -1) {
        csletr.push(maxid); // 0（ID）
      } else {
        csletr.push(select_news_id); // 0（ID）
      }

      csletr.push(PublishDate); // 1（公開日時）
      csletr.push(Title); // 2（タイトル）
      csletr.push(Content); // 3（内容）

      arrStr = JSON.stringify(csletr);
      body.arrStr = arrStr;

      // insertとupdateを分岐させる
      if (select_news_id == -1) {
        // insert
        const res = await axios.post("/m_news/insert/auth", body);
        if (res.status === 200) {
          console.log('insert成功');
        } else {
          console.log('insert失敗');
        }
      } else {
        // update
        const res = await axios.post("/m_news/update/auth", body);
        if (res.status === 200) {
          console.log('update成功');
        } else {
          console.log('update失敗');
        }
      }
      console.log('保存処理終了');
      return window.location.href = './G011NewsList';
    } catch (e) {
      console.log("例外が発生しました");
      console.log(e.message);
    }
  }

  return (
    <>
      <div class="mainLinkMenu"></div>
      <div id="homeContents">
        <div class="homeContentsInner">
          <div class="mainCont">
            <div class="selectSearchArea">
              <Container maxWidth="lg">
                <Stack spacing={2}>

                  <h1>{newsMain}</h1>
                  {/* <Box
          component="form"
          sx={{
            '& > :not(style)': { m: 1, width: '25ch' },
          }}
          noValidate
          autoComplete="off"
        > */}
                  {/* <p>公開日時</p> */}
                  {/* {publishDateMsg} */}
                  <TextField required id="PublishDate" type='datetime-local' value={PublishDate}
                    label="公開日時"
                    error={Boolean(publishDateMsg == "" ? false : true)}
                    helperText={publishDateMsg}
                    onChange={e => { setPublishDate(e.target.value) }}
                    sx={{ width: 250 }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />

                  {/* <p>タイトル</p> */}
                  {/* {titleMsg} */}
                  <TextField required id="Title" variant="outlined" value={Title}
                    label="タイトル"
                    multiline
                    rows={4}
                    error={Boolean(titleMsg == "" ? false : true)}
                    helperText={titleMsg}
                    onChange={e => { setTitle(e.target.value) }} />


                  {/* <p>内容</p> */}
                  <TextField
                    multiline
                    // maxRows={5}
                    rows={4}
                    aria-label="maximum height"
                    value={Content}
                    label="内容"
                    onChange={e => { setContent(e.target.value) }}
                  />

                  <Stack spacing={2} direction="row">
                    <Button href="./G011NewsList"
                      style={{ width: "200px", color: "white", textDecoration: "none" }}>
                      戻る
                    </Button>
                    <Button onClick={register} style={{ width: "200px" }}>登録</Button>
                  </Stack>

                  {/* </Box> */}
                </Stack>
              </Container>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default G012NewsEdit;